/**
 * Colour palette for the frame grouping panel: fixed colours for the
 * external/load-bearing groups, a rotating palette for thickness groups, and
 * a fallback for anything unmatched.
 */
export const FrameGroupColors = {
	/** Fixed colours keyed by group id (e.g. `external:true`). */
	base: {
		'external:true': '#22c55e', // Bright Green
		'external:false': '#bfdbfe', // Pale Blue
		'loadBearing:true': '#d946ef', // Magenta
		'loadBearing:false': '#b59855', // Rome Primary
	} as Record<string, string>,
	/**
	 * Palette applied to thickness groups by index. The first seven positions
	 * are reserved for the standard imperial thickness catalogue; the remaining
	 * positions provide distinct colours for custom thicknesses.
	 */
	thickness: [
		'#ec4899',
		'#f59e0b',
		'#10b981',
		'#6366f1',
		'#33c1ff',
		'#a52a2a',
		'#008080',
		'#808000',
		'#7c3aed',
		'#db2777',
		'#2563eb',
		'#ea580c',
		'#65a30d',
		'#0f766e',
	],
	fallback: '#94a3b8',
} as const;
